import React from 'react';
import PlainText from 'ati-ui-react/components/PlainText';
import Currency from '@components/currency-font';
import classnames from 'classnames';
import * as styles from './Claims.scss';
import strings from '../../strings';
import {
  toThousandSeparatedSumma,
  getFormattedText,
  openPassportPopup,
} from '../../utils';

const renderClosedClaims = (closedClaimsCount, url) => (
  closedClaimsCount > 0 &&
  <a
    href={url}
    target="_blank"
    className="glz-link glz-is-gray"
    onClick={e => openPassportPopup(e, url)}
    rel="noreferrer"
  >
    <div>
      {`${closedClaimsCount} ${getFormattedText('regulated', closedClaimsCount)}`}
    </div>
  </a>
);

const Claims = (props) => {
  const {
    activeClaimsCount,
    activeClaimsSum,
    closedClaimsCount,
    visible,
    claimsToUrl,
    claimsArchiveUrl,
    isMobile,
  } = props;

  if (!visible) {
    if (isMobile) return null;

    return (
      <div className={styles.claims}>
        <PlainText secondary className={styles.claims__empty}>—</PlainText>
      </div>
    );
  }

  const activeClaimsSumFormatted = toThousandSeparatedSumma(activeClaimsSum);

  const hasActive = activeClaimsCount > 0;
  if (!hasActive) {
    return (
      <div className={styles.claims}>
        { renderClosedClaims(closedClaimsCount, claimsArchiveUrl) }
      </div>
    );
  }

  return (
    <div className={styles.claims}>
      { activeClaimsCount > 0 &&
        <a
          className={classnames(styles.active, styles.linkLikeBlock, 'glz-link glz-is-dark', { [styles._spacer]: closedClaimsCount })}
          href={claimsToUrl}
          target="_blank"
          onClick={e => openPassportPopup(e, claimsToUrl)}
          rel="noreferrer"
        >
          <div className={styles.redBlock}>{`${activeClaimsSumFormatted}`}</div>
          <div className={classnames(styles.currency, styles.red, styles.big)}>
            <Currency name="ruble" />
          </div>
          <div className={styles.claimsCount}>
            {`${strings.from} ${activeClaimsCount} ${getFormattedText('claims', activeClaimsCount)}`}
          </div>
        </a>
      }
      { closedClaimsCount > 0 &&
        renderClosedClaims(closedClaimsCount, claimsArchiveUrl)
      }
    </div>
  );
};

export default Claims;
